<span
  class="munily-tooltip-trigger"
  [matTooltip]="text"
  [matTooltipPosition]="position"
  [matTooltipDisabled]="disabled"
  matTooltipClass="munily-tooltip-panel"
>
  <mat-icon class="munily-tooltip-trigger__icon material-symbols-rounded">{{ icon }}</mat-icon>
</span>
